var config = require('../config.js')
module.exports = {
  userRealNameVerify: config.host + '/cid/api/v1/user/realNameVerify/c',  // 用户实名认证
  // userRealNameVerify: '/devServerbc/api/v1/user/realNameVerify',  // 用户实名认证
  getLoginUserInfo: config.host + '/cid/api/v1/user/get/c',  // 获取用户
  // getLoginUserInfo: '/devServerbc/api/v1/user/get/c',  // 获取用户
  updateUserInfo: config.host + '/cid/api/v1/user/update/c',  // 更新用户
  changePassword: config.host + '/cid/api/v1/user/changePassword/c',  // 修改密码
  changePasswordByCheckCodeSms: config.host + '/cid/api/v1/sms-code/changePasswd/v2/c', // 通过验证码修改密码之前发验证码的接口
  changePasswordByCheckCode: config.host + '/cid/api/v1/user/changePasswordByCheckCode/c', // 通过验证码修改密码
  forgetPasswordByCheckCode: config.host + '/cid/api/v1/user/forgetPassword/c', // 通过验证码忘记密码
  forgetPasswordParkConsumerSms: config.host + '/cid/api/v1/sms-code/forgetPasswd/v2/c', // 通过验证码忘记密码验证码

//   smsRegisterUser: config.host + '/sys/api/v1/sms/RegisterUser', // 注册短信验证码

}